{
  "appTitle": "Culture Shift",
  "loading": "Loading…",
  "closeButtonLabel": "Close"
}
